import { render, staticRenderFns } from "./OverseasBusiness.vue?vue&type=template&id=e4820ae0&scoped=true"
import script from "./OverseasBusiness.vue?vue&type=script&lang=js"
export * from "./OverseasBusiness.vue?vue&type=script&lang=js"
import style0 from "./OverseasBusiness.vue?vue&type=style&index=0&id=e4820ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4820ae0",
  null
  
)

export default component.exports